import { DAG } from '@pollination-solutions/pollination-sdk'

interface Flow {
  main: DAG
  subFlows: DAG[]
}

export const recipeEntrypoint = (flow: DAG[]): Flow => {
  const main = flow.find((dag) => dag.name === 'main')

  if (!main) {
    throw new Error('Malformed recipe flow. Does not contain "main.yaml".')
  }

  const subFlows = flow.filter((dag) => dag.name !== 'main')

  return { main, subFlows }
}
